module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDE1SDE1VjEySDEyVjE1Wk0xMiAxMC41SDE1VjcuNUgxMlYxMC41Wk03LjUgNkgxMC41VjNINy41VjZaTTEyIDZIMTVWM0gxMlY2Wk03LjUgMTAuNUgxMC41VjcuNUg3LjVWMTAuNVpNMyAxMC41SDZWNy41SDNWMTAuNVpNMyAxNUg2VjEySDNWMTVaTTcuNSAxNUgxMC41VjEySDcuNVYxNVpNMyA2SDZWM0gzVjZaIiBmaWxsPSIjMEM1M0IwIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sideBarMenu/application-active.svg
// module id = 2/Wp
// module chunks = 23